import {Control, defaults as defaultControls} from 'ol/control.js';
import {Modal} from './Modal.js';

var settingsModal;
var infoModal;

export class ServiceControl extends Control {
	constructor(options){
		const element = document.createElement('div');
		super({ element: element, target: options.target });
		self = this;
		
		element.classList.add('service-controls');
        this.panel = document.createElement('div');
        this.panel.className = 'panel';
        element.appendChild(this.panel);
		const settingsBtn = document.createElement('button');
		settingsBtn.className = 'serv_btn serv_settings';
		settingsBtn.setAttribute('title', 'Настройки');
		settingsBtn.setAttribute('aria-label', 'Настройки');
		settingsBtn.innerHTML = '<span>Настройки</span>';
		const infoBtn = document.createElement('button');
		infoBtn.className = 'serv_btn serv_info';
		infoBtn.setAttribute('title', 'Инструкция');
		infoBtn.setAttribute('aria-label', 'Инструкция');
		infoBtn.innerHTML = '<span>Инструкция</span>';
		this.panel.appendChild(settingsBtn);
		this.panel.appendChild(infoBtn);
		//console.log(this.panel);

		//this.panel.innerHTML = '<button class="serv_btn serv_settings" title="Настройки" aria-label="Настройки"><span>Настройки</span></button><button class="serv_btn serv_info" title="Инструкция" aria-label="Инструкция"><span>Инструкция</span></button>';
		
		settingsModal = new Modal({
			title: 'Настройки',
			html: `<span><b>Настройки:</b><br />=== настройки ===</span>`,
		});
		
		infoModal = new Modal({
			title: 'Инструкция',
			html: `<span><b>Инструкция:</b><br />=== инструкция ===</span>`,
		});

		ready(function() {
			settingsBtn.addEventListener('click', function(){settingsModal.showModal();});
			infoBtn.addEventListener('click', function(){infoModal.showModal();});
		});

	}
}

function ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}
